import styled from 'styled-components'
import { theme } from '@provi/provi-components'
import { Body1 } from '~/styles/global'

export const CourseTitle = styled(Body1)<{ isUnavailable?: boolean }>`
  color: ${({ isUnavailable }) => (isUnavailable ? theme.colors.greyPrimary : theme.colors.bluePrimary)};
`
